module.exports = __webpack_public_path__ + "static/media/photo149.38ea075e.jpg";